module.exports = __webpack_public_path__ + "static/img/heavy-modular-frame_64.bd3314e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/heavy-modular-frame_64.png
// module id = ce4l
// module chunks = 0